/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AppointmentBlockerType } from './appointmentBlockerType';
import { AppointmentBlockerTherapist } from './appointmentBlockerTherapist';
import { AppointmentBlockerSeries } from './appointmentBlockerSeries';


/**
 * Serializer for the AppointmentBlocker model.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AppointmentBlocker { 
    readonly id: number;
    blockerType: AppointmentBlockerType;
    therapist: AppointmentBlockerTherapist;
    fromDate: string;
    toDate: string;
    reason?: string | null;
    series?: AppointmentBlockerSeries;
}
export const AppointmentBlocker_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentBlocker_blockerType_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentBlocker_therapist_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentBlocker_fromDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentBlocker_toDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentBlocker_reason_Validators: ValidatorFn[] =
    [  Validators.maxLength(255),];

export const AppointmentBlocker_series_Validators: ValidatorFn[] =
    [ ];


